import React, { useState, useEffect } from "react";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { toast } from "react-toastify";
import moment from "jalali-moment";

// import JS files
import TableIconModal from "../../../shares/TableIconModal";
import useFetch from "../../../../context/useFetch";
import MuiButton from "../../../shares/MuiButton";
import OrderCardLeftPartTemplate from "../../../shares/OrderCardLeftPartTemplate";
import SizeTextGrid from "../../../shares/SizeTextGrid";
import AdminOrderCard from "../../../admin-panels/shares/AdminOrderCard";
import { useSetting } from "../../../../context/SettingContext";
import { fixNumbers } from "../../../../utils";
// import { defaultRingSize } from "../../../../constants/constants";

const BangleOrderInputFirst = (props) => {
  const { defaultRingSize } = useSetting();
  const [openModal, setOpenModal] = useState(false);

  const [currentOerdersDetail, setCurrentOerdersDetail] = useState({});
  const [initialValues, setInitialValues] = useState({ 1: [0, 0, 0, 0, 0, 0] });
  const [nums, setNums] = useState(new Array(defaultRingSize + 1).fill(""));
  const update_nums = (ringId, ind, nValue) => {
    let beforeNums = { ...initialValues };

    beforeNums[ringId][ind] = nValue;
    setInitialValues(beforeNums);
  };
  const [itemIsActive, setItemIsActive] = useState(false);
  const getCreateOrderDetailsApi = useFetch({
    method: "get",
    url: `Bangle_Service/${props.selectedRow?.id}/provider_get_bangle_detail_in_tab_two`,
    trigger: false,
    // setter: setCurrentOerdersDetail,
    argFunc: (res) => {
      let tmp = { ...initialValues };
      setCurrentOerdersDetail(res[0]);

      res.map((item, ind) => {
        //   console.log("object", item);
        // tmp[item.id] = [];
        console.log(item);
        tmp[1][0] = item.table_diff_size_one_num;
        tmp[1][1] = item.table_diff_size_two_num;
        tmp[1][2] = item.table_diff_size_three_num;
        tmp[1][3] = item.table_diff_size_four_num;
        tmp[1][4] = item.table_diff_size_five_num;
        tmp[1][5] = item.table_diff_size_six_num;
      });
      console.log(tmp, "tmp");
      // getOrderDetailsBangleApi.reFetch();
      setInitialValues(tmp);
      setItemIsActive(true);

    },
    errMessage: (mess) => {
      // toast.error("خطایی رخ داده است", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
    },
  });

  // console.log(initialValues);

  const [selectedItem, setSelectedItem] = useState();
  const [patchData, setPatchData] = useState();
  const [childrenItemDate, setChildrenItemDate] = useState();
  const [selecteItemStatus, setSelectItemStatus] = useState();
  const [editable, setEditable] = useState(false);
  const [orderBangleStatus, setOrderBangleStatus] = useState({
    not_ready_list: [],
    ready_list: [],
    unchange_list: [],
  });
  const getOrderDetailsBangleApi = useFetch({
    method: "get",
    url: `ProviderOrder_Service/${props.selectedRow?.id}/admin_get_bangle_detail_for_provider_order`,
    trigger: false,
    // setter: setCurrentOerdersDetail,
    // params: { admin_change_item: statusFilter },
    argFunc: (res) => {
      setOrderBangleStatus({
        not_ready_list: res.not_ready_list,
        ready_list: res.ready_list,
        unchange_list: res.unchange_list,
      });

      let bangle_id = [];

      currentOerdersDetail.results.map((it, ind) => {
        if (res.ready_list.includes(it.id)) bangle_id.push(it.id);
      });

      // setBangleCheckBox(bangle_id);
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  const updateOrderApi = useFetch({
    method: "post",
    url: `Bangle_Service/${props.selectedRow?.id}/provider_onprogress_tab_three_first`,
    trigger: false,
    data: {
      admin_size_one_num: initialValues[1][0],
      admin_size_two_num: initialValues[1][1],
      admin_size_three_num: initialValues[1][2],
      admin_size_four_num: initialValues[1][3],
      admin_size_five_num: initialValues[1][4],
      admin_size_six_num: initialValues[1][5],
    },

    argFunc: (res) => {
      // toast.success("سفارش با موفقیت به سفارش های جاری منتقل شد", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
      // props.setNewOerdersList({ results: [] });

      setOpenModal(false);
      getCreateOrderDetailsApi.reFetch();
      props.getRequestListApi.reFetch();
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const updateDetailsApi = useFetch({
    method: "patch",
    url: `ProviderOrderItem_Service/${selectedItem}`,
    trigger: false,
    data: patchData,

    argFunc: (res) => {
      // toast.success("ویرایش سفارش  با موفقیت انجام شد.", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
      getCreateOrderDetailsApi.reFetch();
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const admin_change_order_to_on_onprogress = () => {
    updateOrderApi.reFetch();
  };

  useEffect(() => {
    if (openModal == true)
      if (props.selectedRow !== undefined)
        if (props.selectedRow.hasOwnProperty("id")) {
          getCreateOrderDetailsApi.reFetch();
        }
  }, [openModal]);
  console.log(currentOerdersDetail);
  return (
    <>
      <TableIconModal
        width="w-11/12"
        icon={<RemoveRedEyeIcon />}
        isOverflow={true}
        isNotBackdropClick={true}
        openModal={openModal}
        setOpenModal={setOpenModal}
      >
        <div>
          <div className="flex justify-between items-center">
            <div className="flex items-center">
              <div className="">
                <span className="show-label">
                  کد سفارش:{" "}
                  <span className="show-value">
                    {" "}
                    {currentOerdersDetail?.bangle?.show_name}/
                    {currentOerdersDetail?.bangle?.brand_name}/
                    {currentOerdersDetail?.bangle?.show_name}/
                    {currentOerdersDetail?.bangle?.fa_gender}/
                    {currentOerdersDetail?.bangle?.fa_color}
                  </span>
                </span>
              </div>
              {/* <div className="mr-4">
                <span className="show-label">
                  تولیدکننده:{" "}
                  <span className="show-value">
                    {" "}
                    {currentOerdersDetail.detail?.name}
                  </span>
                </span>
              </div> */}
            </div>
            <div className="md:block">
              <MuiButton
                onClick={admin_change_order_to_on_onprogress}
                variant="contained"
                // icon={<DoneIcon />}
                color="primary"
                text="تایید نهایی "
                disabled={updateOrderApi.loading}
              />
            </div>
          </div>
          <div className="border-b border-dashed my-2"></div>
          <SizeTextGrid haveExtraCol have5Col />
          <div className="overflow-scroll max-h-96">
            {/* {currentOerdersDetail.map((item, index) => {
              return [
                <AdminOrderCard
                  update_ring_item={update_ring_item}
                  dontShowStoreName
                  // edit_ring_item={edit_ring_item}
                  showAcceptBtn
                  DontshowEditIconForAdmin
                  item={item}
                  move_date_to_parent={move_date_to_parent}
                  baseFromRing
                  adminNeedDifference
                  ShowOrderCode
                > */}
            {itemIsActive && (
              <OrderCardLeftPartTemplate
                nums={nums}
                update_nums={update_nums}
                dynamicMap={true}
                data_item={initialValues[1]}
                adminDidntNeedCustomerRequestNum
                DontShowAcceptItem
                showAcceptNumber
                adminNeedShowAcceptNumberDefaults
                // showReturnNumber
                // adminCantEdit
                ringId={1}
                // adminCantEdit={itemIsActive[item.id] ? true : false}

                // adminNeedColor
              />
            )}
          </div>
        </div>
      </TableIconModal>
    </>
  );
};

export default BangleOrderInputFirst;
